<template>
  <v-container>
    <v-card>
      <v-card-title>
        Kompanije kod vendora
      </v-card-title>
      <v-card-subtitle>
        <v-row justify="end">
          <v-col cols="12" sm="4" class="py-0">
            <v-text-field
              v-model="queryString"
              append-icon="mdi-magnify"
              label="Pretraga"
              single-line
              hide-details
              clearable
              @keyup.enter.prevent='onEnterSearch'
              @click:clear='onClearSearch()'
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-subtitle>
      <v-data-table
      :headers="headers"
      :items="listOfCompanies"
      :server-items-length="totalCompaniesCount"
      :options.sync="options"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50],
        'items-per-page-text': 'Broj redova po stranici:'
      }"
      no-data-text="Nema rezultata"
      loading-text="Učitavanje podataka... Molimo sačekajte"
      class="elevation-1 row-pointer"
      width="100%"
      @click:row="onRowClick"
      >
        <template v-slot:[`item.active`]="{ item }">
          <v-avatar :color="getActiveColor(item)" size="15"></v-avatar>
        </template>

        <template v-slot:[`item.subscriptionState`]="{ item }">
          {{ getSubscriptionStateText(item.subscriptionState) }}
        </template>

        <template v-slot:[`item.vendorName`]="{ item }">
          {{ item.companyVendorInfos[0].vendorName }}
        </template>

      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import * as apiCompanies from '../api/companies.js';
import * as utils from '../utils.js';

export default {
  name: "VendorCompaniesList",
  data: function () {
    return {
      loading: false,
      options: {
        sortDesc: [true]
      },
      queryString: null,
      isSearchByID: false,
      listOfCompanies: [],
      totalCompaniesCount: 0,
      headers: [
          { text: 'ID', value: 'id', width: "5%" },
          { text: 'PIB', value: 'tid', width: "10%" },
          { text: 'MB', value: 'mn', width: "10%" },
          { text: 'Naziv', value: 'name', width: "25%" },
          { text: 'Adresa', value: 'address', width: "25%" },
          { text: 'Grad', value: 'town', width: "10%" },
          { text: 'Vendor', value: 'vendorName', width: "15%" }
      ]
    }
  },
  watch: {
    options: {
      handler () {
        this.options.search = this.queryString;
        this.getCompaniesFromAPI()
      },
      deep: true,
    }
  },
  mounted () {
    this.getCompaniesFromAPI()
  },
  methods: {
    getCompaniesFromAPI() {
      this.loading = true

      apiCompanies.getOtherVendorsCompaniesList(this.options, this.$store.getters.token)
        .then(response => response.json())
        .then(responseData => {
          this.loading = false;
          this.listOfCompanies = responseData.companies;
          this.totalCompaniesCount = responseData.totalCount;
        })
        .catch(() => {
          this.listOfCompanies = [];
          this.loading = false;
          this.totalCompaniesCount = 0;
        })
    },

    getSubscriptionStateText(subscriptionState) {
      return utils.getSubscriptionStateText(subscriptionState);
    },

    onEnterSearch() {
      this.options.search = this.queryString
      this.options.page = 1
      this.getCompaniesFromAPI()
    },

    onClearSearch() {
      this.options.search = ''
      this.queryString = ''
      this.getCompaniesFromAPI()
    },

    onRowClick(company) {
      let route = this.$router.resolve({ path: '/companies/' + company.id });
      window.open(route.href, '_blank');
    },

     onSwitchSearch() {
      this.options.page = 1;
      this.options.isSearchByID = this.isSearchByID;
      this.options.search = this.queryString;
      this.getCompaniesFromAPI();
    },

    getActiveColor(item) {
      if (item.active)
        return "success";
      else
        return "error";
    },
  }
}
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
